export default defineNuxtRouteMiddleware(async () => {
  if (!useSupabaseUser().value) return navigateTo('/login')
  const { load, isSystemAdmin } = useSchoolMemberships()
  await load(true)
  if (!isSystemAdmin.value) return navigateTo('/')
})
